"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _clsx = _interopRequireDefault(require("clsx"));
var _react = _interopRequireDefault(require("react"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _Button = require("../Button");
var ButtonGroup = function ButtonGroup(props) {
  var _buttons$filter;
  var _id = props._id,
    buttons = props.buttons,
    _props$layout = props.layout,
    layout = _props$layout === void 0 ? 'vertical' : _props$layout,
    _props$hide = props.hide,
    hide = _props$hide === void 0 ? false : _props$hide,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    className = props.className;
  var showButton = Boolean((buttons === null || buttons === void 0 ? void 0 : buttons.length) && !hide);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('button-group'), (0, _getPrefixCls.getPrefixCls)("button-group__".concat(layout)), className)
  }, showButton && (buttons === null || buttons === void 0 ? void 0 : (_buttons$filter = buttons.filter(function (btn) {
    return !btn.hidden;
  })) === null || _buttons$filter === void 0 ? void 0 : _buttons$filter.map(function (button, index) {
    return /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({
      _id: _id,
      disabled: disabled,
      key: index
    }, button));
  })));
};
exports.ButtonGroup = ButtonGroup;